import React, { useEffect, useState } from "react";
import Select from "react-select";
import Modal from "react-bootstrap/Modal";
import apiClient from "../apiClient";
import { GET_ALL_APPLICATION, ASSIGN_APPLICATION_TO_DIRECTORY } from "../apiClient/apiEndpoints";
import { SSO_URL } from "../env";
import { CloseIcon } from "../assets/Icons";
import { useParams } from "react-router-dom";
import { debounce } from "../components/common/Debounce";

const defaultValues = {
  applications: [],
};
const defaultErrorValues = {
  applications: { active: false, message: "Please Select Atleast one Application" },
};

const AddDirectoryApplication = ({
  openModal,
  setOpenModal,
  alreadyAssignApplications,
  fetchDirectoryApplications,
}) => {

  const [list, setList] = useState([]);
  const [error, setError] = useState(defaultErrorValues);
  const [loading, setLoading] = useState(false);
  const [formValues, setFormValues] = useState(defaultValues);
  const [responseError, setResponseError] = useState("");
  const { id } = useParams();

  const fetchAppList = async () => {
    try {
      const data = await apiClient.get(`${SSO_URL}${GET_ALL_APPLICATION}`);
      const assignedAppIds = alreadyAssignApplications.map((e) => e.uuid);
      const applicationList = data.filter((e) => !assignedAppIds.includes(e.uuid)).map((item) => ({ label: item.name, value: item.uuid }));
      setList(applicationList);
    } catch (error) {
      console.log(error);
    }
  };

  const handleFormChange = (key, value) => {
    setFormValues((prev) => ({ ...prev, [key]: value }));
  };

  const closeModal = () => {
    setFormValues(defaultValues);
    setError(defaultErrorValues);
    setOpenModal(false);
    setResponseError("");
  };

  const checkForError = () => {
    const newErrors = JSON.parse(JSON.stringify(defaultErrorValues));
    let hasError = false;
    Object.keys(defaultValues).forEach((key) => {
      if (!formValues[key] || formValues[key].length === 0) {
        newErrors[key].active = true;
        hasError = true;
      } else {
        newErrors[key].active = false;
      }
    });
    setError(newErrors);
    return hasError;
  };

  const handleSave = async () => {
    if(checkForError()) return;
    try {
      setLoading(true);
      await apiClient.post(`${SSO_URL}${ASSIGN_APPLICATION_TO_DIRECTORY}/${id}`, {
        payload: formValues?.applications.map(e => e.value),
      });
      fetchDirectoryApplications();
      closeModal();
    } catch (error) {
      setResponseError(error?.response?.data?.message);
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (openModal) { fetchAppList() }
  }, [openModal]);

  const debouncedHandleSave = debounce(handleSave, 500);

  return (
    <Modal show={openModal} size="md" centered onHide={closeModal}>
      <Modal.Header className="modalheader">
        Add Application
        <span onClick={closeModal}>
          <CloseIcon />
        </span>
      </Modal.Header>

      <Modal.Body className="pb-0">
        <div className="row">
          <div className="col-12 standardinput">
            <label className="mb-2">
              Select Application <span>*</span>
            </label>
            <div className="forselect-input">
              <Select
                theme={(theme) => ({
                  ...theme,
                  borderRadius: 5,
                  colors: {
                    ...theme.colors,
                    primary50: "#ca373c50",
                    primary25: "#ca373c50",
                    primary: "#ca373c70",
                    danger: "#000000",
                    neutral30: "#00000050",
                  },
                })}
                isMulti
                options={list}
                onChange={(value) => handleFormChange("applications", value)}
              />
              <p className="error">{error.applications.active && error.applications.message}</p>
            </div>
          </div>
          <div className="col-12 standardinput mt-3">
            <p className="error">{responseError}</p>
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer className="footerbtn">
        <button className="cancel" onClick={closeModal}>
          Cancel
        </button>
        {!loading ? (
          <button className="save" onClick={debouncedHandleSave}>
            Save
          </button>
        ) : (
          <button className="loading save">
            <svg viewBox="25 25 50 50">
              <circle r="20" cy="50" cx="50"></circle>
            </svg>
          </button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default AddDirectoryApplication;
